import React, { useState, useEffect } from "react";

// Absolute (/#…) so the links also work from the capability sub-pages, not just
// the homepage. On the homepage they behave as normal in-page anchors.
const LINKS = [
  { href: "/#work", label: "Work" },
  { href: "/#capabilities", label: "Capabilities" },
  { href: "/#about", label: "About" },
  { href: "/#team", label: "Team" },
  { href: "/#contact", label: "Contact" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);

  // Close menu whenever the user navigates to a hash or resizes up past mobile
  useEffect(() => {
    const close = () => setOpen(false);
    window.addEventListener("hashchange", close);
    const onResize = () => { if (window.innerWidth > 860) setOpen(false); };
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("hashchange", close);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  return (
    <nav className="nav" role="navigation" aria-label="Primary">
      <div className="wrap nav-inner">
        <a href="/" className="nav-brand">
          CoreLink <em>AI</em>
        </a>

        <button
          type="button"
          className="nav-toggle"
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
        >
          <span /><span /><span />
        </button>

        <ul className={`nav-links${open ? " is-open" : ""}`}>
          {LINKS.map((l) => (
            <li key={l.href}>
              <a href={l.href} onClick={() => setOpen(false)}>{l.label}</a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
